import React from 'react'
import PropTypes from 'prop-types'

// Components
import ScrollSection from '../ScrollSection'
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import RichText from '../RichText'
import Spacer from '../Spacer'
import AnimateSplitText from '../animation/AnimateSplitText'
import AmenitiesItem from '../AmenitiesItem'

// Styles
import { Label } from '../TextStyles'
import { AmenitiesMain, AmenitiesList } from './index.style'

const Amenities = ({ id, heading, text, disclaimer, listItems, linkId }) => (
  <ScrollSection id={linkId}>
    <AmenitiesMain>
      <Spacer size={[120, 230]} />

      <Container>
        <Grid>
          <GridItem
            tabletP={8}
            tabletPStart={2}
            tabletL={4}
            tabletLStart={2}
            contained={3}
            containedStart={2}
          >
            <RichText
              id={`${id}-heading`}
              content={heading}
              delayEm={true}
              forceHeading
            />
          </GridItem>

          <GridItem tabletP={8} tabletPStart={2} tabletL={4} tabletLStart={2}>
            <Spacer size={[20, 30]} />

            {text && <RichText id={`${id}-text`} content={text} />}

            {disclaimer && (
              <>
                <Spacer size={[20]} />

                <AnimateSplitText id={`${id}-disclaimer`}>
                  <Label>{disclaimer}</Label>
                </AnimateSplitText>
              </>
            )}
          </GridItem>

          <GridItem
            tabletP={8}
            tabletPStart={2}
            tabletL={5}
            tabletLStart={7}
            deskL={4}
            deskLStart={7}
          >
            <AmenitiesList>
              {listItems?.map((item, itemIndex) => {
                return (
                  <AmenitiesItem
                    key={itemIndex}
                    id={`${id}-amenity-${itemIndex}`}
                    {...item}
                  />
                )
              })}
            </AmenitiesList>
          </GridItem>
        </Grid>
      </Container>

      <Spacer size={[160, 286]} />
    </AmenitiesMain>
  </ScrollSection>
)

Amenities.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.object,
  text: PropTypes.object,
  disclaimer: PropTypes.string,
  listItems: PropTypes.array,
  linkId: PropTypes.string,
}

export default Amenities
